namespace TabAurous.Inventory {
    export interface MaterialReceiptRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        VoucherTypeName?: string;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        GstVat?: string;
        Pan?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        BillAddId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: MaterialReceiptItemsRow[];
        DepartmentId?: number;
        RoundOff?: number;
        PostingDate?: string;
        IsPosted?: boolean;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        Username?: string;
    }

    export namespace MaterialReceiptRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.MaterialReceipt';
        export const deletePermission = 'Inventory:MaterialReceipt:Delete';
        export const insertPermission = 'Inventory:MaterialReceipt:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:MaterialReceipt:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            VoucherTypeName = "VoucherTypeName",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            GstVat = "GstVat",
            Pan = "Pan",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            BillAddId = "BillAddId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            DepartmentId = "DepartmentId",
            RoundOff = "RoundOff",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            Username = "Username"
        }
    }
}
